import { render } from "./reportEatDesktime.vue?vue&type=template&id=81ef2598"
import script from "./reportEatDesktime.vue?vue&type=script&lang=js"
export * from "./reportEatDesktime.vue?vue&type=script&lang=js"

import "./reportEatDesktime.vue?vue&type=style&index=0&id=81ef2598&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__